<div class="header">
  <h2>{{'PROFILE.PASSWORD.TITLE' | translate}}</h2>
  <hr>
</div>

<div class="m-t-20 form-center">
  <div class="form-group row">
    <label class="col-sm-3 col-form-label">{{'PROFILE.PASSWORD.OLD-PASSWORD' | translate}}</label>
    <div class="col-sm-9">
      <div (click)="showPassword('old')" [class]="isShowPassword.old ? 'fa fa-eye fa-eye-slash field-icon':'fa fa-eye field-icon'"></div>
      <input [type]="isShowPassword.old ? 'text' : 'password'" class="form-control" placeholder="{{'PROFILE.PASSWORD.OLD-PASSWORD' | translate}}" [(ngModel)]="oldPassword">
    </div>
  </div>
  <hr>
  <div class="form-group row">
    <label class="col-sm-3 col-form-label">{{'PROFILE.PASSWORD.NEW-PASSWORD' | translate}}</label>
    <div class="col-sm-9">
      <div (click)="showPassword('new')" [class]="isShowPassword.new ? 'fa fa-eye fa-eye-slash field-icon':'fa fa-eye field-icon'"></div>
      <input [type]="isShowPassword.new ? 'text' : 'password'" class="form-control" placeholder="{{'PROFILE.PASSWORD.NEW-PASSWORD' | translate}}" [(ngModel)]="newPassword">
    </div>
  </div>
  <div class="form-group row">
    <label class="col-sm-3 col-form-label">{{'PROFILE.PASSWORD.CONFIRM-NEW-PASSWORD' | translate}}</label>
    <div class="col-sm-9">
      <div (click)="showPassword('confirm')" [class]="isShowPassword.confirm ? 'fa fa-eye fa-eye-slash field-icon':'fa fa-eye field-icon'"></div>
      <input (paste)="(false)" [type]="isShowPassword.confirm ? 'text' : 'password'" class="form-control" placeholder="{{'PROFILE.PASSWORD.CONFIRM-NEW-PASSWORD' | translate}}" [(ngModel)]="confirmPassword">
      <p class="text-red" *ngIf="errorMessage">{{errorMessage}}</p>
      <p class="text-warning" *ngIf="!errorMessage">
        - {{ 'PROFILE.PASSWORD.POLICY.NOT_SIMILAR' | translate }}<br>
        - {{ 'PROFILE.PASSWORD.POLICY.LENGTH' | translate }}<br>
        - {{ 'PROFILE.PASSWORD.POLICY.CHARACTERS' | translate }}<br>
        - {{ 'PROFILE.PASSWORD.POLICY.NOT_MATCH_LAST_PASSWORD' | translate }}
      </p>
    </div>
  </div>
  <div class="text-right">
    <button class="btn btn-primary" (click)="submit()">{{'PROFILE.PASSWORD.CONFIRM' | translate}}</button>
  </div>
</div>



// WEBPACK FOOTER //
// /opt/app/src/app/features/profile/profile-password/profile-password.component.html